import { Cartouche } from '@brig/theme/components';
import { button, paper } from '@brig/theme/styles';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { artCredits } from '../ships/credits.ts';
import { useDocumentTitle } from '../useDocumentTitle.ts';
import * as styles from './Credits.css.ts';

export function Credits() {
  const { t } = useTranslation();
  useDocumentTitle(t('credits.pageTitle'));
  return (
    <main className={styles.sea}>
      <section className={`${paper} ${styles.sheet}`}>
        <Cartouche>{t('credits.title')}</Cartouche>
        <h2 className={styles.heading}>{t('credits.artwork')}</h2>
        <ul className={styles.list}>
          {artCredits().map((line) => (
            <li key={line}>{line}</li>
          ))}
          <li>{t('credits.ownArt')}</li>
        </ul>
        <Link to="/" className={button({ tone: 'seal' })}>
          {t('notFound.back')}
        </Link>
      </section>
    </main>
  );
}
